import styled, { css } from 'styled-components';
import { Anchor, token } from '@zillow/constellation';
import { MUIBreakpointXs } from '../../constants';

const zillowPride = css`
  .cls-1 {
    fill: #006aff;
  }
  .cls-2 {
    fill: #c02bdd;
  }
  .cls-3 {
    fill: #0942b3;
  }
  .cls-4 {
    fill: #129f03;
  }
  .cls-5 {
    fill: #fbe202;
  }
  .cls-6 {
    fill: #ff8b00;
  }
  .cls-7 {
    fill: #fd0600;
  }
  .cls-8 {
    fill: #794c11;
  }
  .cls-9 {
    fill: #5bd1f9;
  }
  .cls-10 {
    fill: #f5a8b8;
  }
`;

const zrmPride = css`
  .black {
    fill: #000;
  }
  .st0 {
    fill: #006bff;
  }
  .st1 {
    fill: #006aff;
  }
  .st2 {
    fill: #985dff;
  }
  .st3 {
    fill: #17b036;
  }
  .st4 {
    fill: #ffd237;
  }
  .st5 {
    fill: #f2a619;
  }
  .st6 {
    fill: #ff5a50;
  }
  .st7 {
    fill: #785020;
  }
`;

export const StyledLogoAnchor = styled(Anchor)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const StyledHeaderNavigationLogoDesktop = styled.div`
  position: relative;

  height: 44px;
  width: 148px;

  svg {
    color: ${token('colors.brand')};
  }
`;

export const StyleLogoZRMPrideDesktop = styled.div`
  width: 148px;
  height: 46px;

  ${zrmPride};
`;

export const StyleLogoZillowPrideDesktop = styled.div`
  width: 148px;
  height: 33px;

  ${zillowPride};
`;

export const StyledLogoPrideMobile = styled.div`
  width: 232px;
  height: 22px;

  ${zrmPride};
`;

export const StyledLogoZillowPrideMobile = styled.div`
  width: 120px;
  height: 28px;

  ${zillowPride};
`;

export const StyledHeaderNavigationLogoMobile = styled.div<{ alternate: boolean }>`
  position: relative;

  height: ${(props) => (props.alternate ? '24px' : '26px')};
  width: ${(props) => (props.alternate ? '232px' : '120px')};
  margin-left: 20px;

  svg {
    color: ${token('colors.brand')};
  }

  @media screen and (min-width: ${MUIBreakpointXs}) {
    margin-left: 0;
  }
`;
